import { graphql } from '@/gql';
import type { RefundCustomChargeCreditsMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const refundCustomChargeCredits = async ({ payerType, amount, id, notes }: RefundCustomChargeCreditsMutationVariables) => {
  const response = await mutationExecute({
    variables: {
      payerType,
      amount: Number(amount),
      id,
      notes,
    },
    mutation: graphql(`
      mutation RefundCustomChargeCredits($notes: String!, $payerType: String!, $amount: Float!, $id: String!) {
        refundCustomChargeCredits(notes: $notes, payerType: $payerType, amount: $amount, id: $id)
      }
    `),
  });

  return response.data?.refundCustomChargeCredits ?? '';
};
